export default __webpack_public_path__ + "static/media/instagram.db2612bd.png";